import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {},

  rowStatus: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    // alignContent: 'center',
    // marginTop: theme.spacing(6),
    // marginBottom: theme.spacing(6),
  },

  searchInput: {
    marginRight: theme.spacing(1),
  },

  overviewUserCard: {
    width: '19%',
    height: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },

  overviewPlatformCard: {
    width: '22%',
    height: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },

  overviewCompanyCard: {
    width: '30%',
    height: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },

  overviewUserSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  overviewPlatformSummary: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  periodChoiceButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    // marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },

  choiceButtons: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  },

  greenIcon: {
    backgroundColor: '#2DCE98 !important',
  },

  blackIcon: {
    backgroundColor: '#4D4F5C !important',
  },

  blueIcon: {
    backgroundColor: '#176AE6 !important',
  },

  redIcon: {
    backgroundColor: '#F53C56 !important',
  },

  icon: {
    marginRight: theme.spacing(1),
  },

  overviewRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(4),
      flexDirection: 'column',
      alignItems: 'normal',
    },
  },

  quickAccessContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },

  quickAccessTitle: {
    flex: '0 0 auto',
  },

  topButtons: {
    flex: '1 1 auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    '@media (max-width: 1439.95px)': {
      gap: theme.spacing(1),
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  button: {
    flex: '0 0 auto',
    height: 40,
    padding: theme.spacing(0, 2),
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    '@media (max-width: 1439.95px)': {
      padding: theme.spacing(0, 1.25),
      fontSize: '0.75rem',
      '& svg': {
        fontSize: 18,
        marginRight: theme.spacing(0.75),
      },
    },
    '@media (max-width: 1199.95px)': {
      flex: '1 1 auto',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}));
